import { createSlice } from '@reduxjs/toolkit';
import { addNewUser, editUser, fetchUsers } from './user.actions';
import initialState from './user.initialState';

export const userSlice = createSlice({
  name: 'userSlice',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(addNewUser.pending, (state) => {
        state.addNewUser.loading = true;
        state.addNewUser.error = null;
      })
      .addCase(addNewUser.rejected, (state, action) => {
        state.addNewUser.loading = false;
        state.addNewUser.error = action.payload;
        state.addNewUser.data = {};
      })
      .addCase(addNewUser.fulfilled, (state, action) => {
        state.addNewUser.data = action.payload;
        state.addNewUser.loading = false;
        state.addNewUser.error = null;
      })
      .addCase(editUser.pending, (state) => {
        state.editUser.loading = true;
        state.editUser.error = null;
      })
      .addCase(editUser.rejected, (state, action) => {
        state.editUser.loading = false;
        state.editUser.error = action.payload;
        state.editUser.data = {};
      })
      .addCase(editUser.fulfilled, (state, action) => {
        state.editUser.data = action.payload;
        state.editUser.loading = false;
        state.editUser.error = null;
      })
      .addCase(fetchUsers.pending, (state) => {
        state.users.loading = true;
        state.users.error = null;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.users.loading = false;
        state.users.error = action.payload;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        const { users, total } = action.payload;
        state.users.data = users;
        state.users.total = total;
        state.users.loading = false;
        state.users.error = null;
      });
  },
});
